/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import AppDispatcher from '../../core/AppDispatcher'
import { Record } from 'immutable'
import RoomEvent from '../../event/RoomEvent'

const SettingSensorState = Record({
  alertEmailChanged: false
})

class SettingSensorStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return new SettingSensorState()
  }

  reduce(state, action) {
    switch (action.type) {
      case RoomEvent.onEdit:
        return state.merge({ alertEmailChanged: true })
      default:
        return state
    }
  }
}

export default new SettingSensorStore()
